import React, { type PropsWithChildren } from 'react';
import styles from './styles.module.css';

type TextProps = PropsWithChildren<{
  className?: string;
  as?: keyof React.JSX.IntrinsicElements;
  dataTestId?: string;
}>;

export function Text({
  as: Tag = 'div',
  children,
  className,
  dataTestId,
}: TextProps) {
  return (
    <Tag data-testid={dataTestId} className={className ?? styles.text}>
      {children}
    </Tag>
  );
}
